// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__374p9","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__opfRE"};